import { render, staticRenderFns } from "./Menlist.vue?vue&type=template&id=5423910c&scoped=true"
import script from "./Menlist.vue?vue&type=script&lang=js"
export * from "./Menlist.vue?vue&type=script&lang=js"
import style0 from "./Menlist.vue?vue&type=style&index=0&id=5423910c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423910c",
  null
  
)

export default component.exports